import { Injectable } from '@angular/core';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import {Observable} from 'rxjs';
import {tap} from 'rxjs/operators'
import { ERequestTypes } from '@modweb5/sharedEnums/requestTypes.enum';
import {environment} from '@modweb5/environments/frontends/environment';
import { UserService } from '@modweb5/sharedServices/userService/user.service';
import { ObservableService } from '@modweb5/sharedServices/observableService/observable-service.service';
import { TServerResponse } from '@modweb5/interfaces/serverResponse.interface';




@Injectable({
  providedIn: 'root'
})
export class DataHttpService {


	// dataStorageEntityMap - zde jsou uloženy v Map všechny záznamy všech entit. 
	// Jakýkoliv záznam z jakékoliv entity lze jednoduše získat pomocí funkce getOneRecordFromDataMap
	
	watermarkConfig: any;

  constructor(
		private observableService: ObservableService,
		private readonly _http: HttpClient,
		private _userService: UserService
	) {
	}


	// ----------------------------------------------------------------------------------------------
	public processServerRequest$(requestType: ERequestTypes, body: any, params: Array<any>, existTokens, timestamp): Observable<TServerResponse> {
	// ----------------------------------------------------------------------------------------------

		let oraxUser;

		if (environment.projectGroup === 'standard') {
			const us1 = this._userService.getUserHash();
			const us2 = this._userService.getLoginHash();
			const us3 = this._userService.getPCHash();
			if (us3 === null) {
				oraxUser = JSON.stringify({us1, us2});
			} else {
				oraxUser = JSON.stringify({us1, us2, us3});
			}
		} else if (environment.projectGroup === 'lacDB') {
			const lcnt = this._userService.getUserLCNT();
			oraxUser = JSON.stringify({lcnt});
		}

		const serverUrl = `${environment.serverUrl}/ajax_server.php`;

		const pHeaders = {
				'x-orax-version': '1',
				'x-orax-timestamp': timestamp,
				'x-orax-exist-tokens': existTokens,
				'x-orax-user': oraxUser,
				'x-orax-data-request': JSON.stringify(params),
				'x-orax-e2e-test': this.getE2ETestValue()
				// 'Content-Type': undefined
			}

		const httpOptions = {
			headers: new HttpHeaders(pHeaders)
		};

/*
		console.log(serverUrl);
		console.log('pHeaders');
		console.log(JSON.stringify(pHeaders));
		console.log('requestType');
		console.log(requestType);
		console.log('body');
		console.log(body);
		console.log('params');
		console.log(params);
		console.log('existTokens');
		console.log(existTokens);
*/

		switch (requestType) {
			case ERequestTypes.DELETE:
					return this._http.delete<TServerResponse>(serverUrl, { ...httpOptions, responseType: 'json' as 'json' }).pipe(
							tap(response => {
								this._userService.setUser(response.system.user);
									// Manipulace s odpovědí (pokud potřeba)
							})
					);
			case ERequestTypes.GET:
				return this._http.get<any>(serverUrl, httpOptions).pipe(
					tap(response => {
						// console.log('response GET');
						// console.log(JSON.stringify(response));
						this.observableService.emitIsE2ETest((response.system['e2e-test'] === 'yes'));
						if (params[0]['token'] !== 'checkUserAuthentication') {
							this._userService.setUser(response.system.user);
						}
					})
					// map(response => response.data)
				);
			case ERequestTypes.POST:

				// httpOptions.headers.set('Content-Type', 'multipart/form-data');
				return this._http.post<any>(serverUrl, body, httpOptions).pipe(
					tap(response => {
						this._userService.setUser(response.system.user);
						// console.log('response POST');
						// console.log(response);
					})
					// map(response => response.data)
				);

			case ERequestTypes.PUT:
				return this._http.put<any>(serverUrl, body, httpOptions).pipe(
					tap(response => {
						this._userService.setUser(response.system.user);
						// console.log('response PUT');
						// console.log(JSON.stringify(response));
					})
					// map(response => response)
				);
		}
	}


	//-----------------------------------------------------------------------------------------------
	private getE2ETestValue(): string {

		if (typeof window['ident-cypress-e2e'] === typeof undefined) {
			return 'no';
		} else {
			return window['ident-cypress-e2e'];
		}
	}



}
